import { render, staticRenderFns } from "./LeftSection.vue?vue&type=template&id=07cfab87&scoped=true&"
import script from "./LeftSection.vue?vue&type=script&lang=js&"
export * from "./LeftSection.vue?vue&type=script&lang=js&"
import style0 from "./LeftSection.vue?vue&type=style&index=0&id=07cfab87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cfab87",
  null
  
)

export default component.exports